import { render } from "./_vCardSocial.vue?vue&type=template&id=54849b84"
import script from "./_vCardSocial.vue?vue&type=script&lang=js"
export * from "./_vCardSocial.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__